import React from "react";
import { Box, Button, ThemeProvider, createTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import { CustomerInventoryState } from "../models/models";
import { selectStockItem } from "../customerInventorySlice";
import { useNavigate } from "react-router-dom";
import Title from "./details/Title";
import Main from "./details/Main";
import useTranslation from "../../../shared/hooks/useTranslation";

const StockItemDetails = () => {
  const { stockItem, loading, success, error } = useAppSelector<CustomerInventoryState>(
    (state: any) => state.customerInventory
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translate } = useTranslation("inventory");

  const handleClose = () => {
    dispatch(selectStockItem(null));
  };

  const handleEditProduct = () => {
    if (!stockItem) {
      return;
    }

    navigate(`/supplier/${stockItem.id}`);
  };

  const theme = createTheme({
    components: {},
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        className="flex flex-col justify-between h-full"
        sx={{ width: 375, background: "#FFF", color: "#333", padding: "16px" }}
      >
        <Box>
          <Title stockItem={stockItem} onClose={handleClose} />

          <Main stockItem={stockItem} className="mt-4" />
        </Box>

        <Box>
          <Button variant="outlined" onClick={handleEditProduct} className="w-full">
            {translate("editItem")}
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
export default StockItemDetails;
